import React from 'react';
import { Button, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CallToAction = () => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            sx={{
                mt: 8,
                py: 6,
                px: 4,
                textAlign: 'center',
                background: '#c1c5c6',
                borderRadius: '16px',
                color: '#20232A',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                mb: 8, // Margen inferior para separarlo del footer
            }}
        >
            <Grid item xs={12}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                        mb: 2,
                    }}
                >
                    ¡Regístrate hoy mismo y <span style={{ color: '#768794' }}>transforma tu futuro</span>!
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        mb: 4,
                        color: '#4D5C61',
                    }}
                >
                    Da el siguiente paso en tu carrera y aprende de los mejores expertos.
                </Typography>
                <Button
                    variant="contained"
                    sx={{
                        px: { xs: 3, md: 4 },
                        py: { xs: 1, md: 1.5 },
                        fontSize: { xs: '0.9rem', md: '1rem' },
                        fontWeight: 600,
                        color: '#fff',
                        backgroundColor: 'rgb(51, 64, 64)',
                        borderRadius: '10px',
                        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            backgroundColor: 'rgb(41, 54, 54)',
                            transform: 'scale(1.05)',
                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
                        },
                    }}
                    onClick={() => navigate('/Contact')}
                >
                    Registrarme
                </Button>
            </Grid>
        </Grid>
    );
};

export default CallToAction;
